import { render } from "./ChangeAvatar.vue?vue&type=template&id=c1c707da"
import script from "./ChangeAvatar.vue?vue&type=script&lang=js"
export * from "./ChangeAvatar.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/wdw-vue build and deploy Teledata PROD/wdw-vue-widgets/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__